import { Box, Button, FormLabel, Image, FormControl } from "@chakra-ui/react";
import SettingsDescription from "../elements/SettingsDescription";
import SettingsHeader from "../elements/SettingsHeader";
import { useDropzone } from "react-dropzone";

import { useCallback, useContext, useEffect, useState } from "react";
import { supabase } from "index";
import { apiRequest } from "utils/api";
import { AlertsContext } from "providers/alerts";
import { isPermissionEnabled, permissionConstants, hasPermission } from "utils/permissionHelper";
import { getErrorMessage } from "utils/errorHandler";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { useCurrentUserQuery } from "modules/tenant/queries/use-current-user-query";

export default function BrandSettings() {
  const { user } = useTenant();
  const { refetch } = useCurrentUserQuery();
  const [companyLogo, setCompanyLogo] = useState("");
  const [loading, setLoading] = useState(false);
  const { showSuccess, showError } = useContext(AlertsContext);
  const { company_configurations } = user.company;

  const permissionEnabled = () => {
    if (hasPermission(user, permissionConstants.editBranding)) {
      return false;
    }
    if (!isPermissionEnabled(user)) {
      //no permissions
      return false;
    }
    return true;
  };

  const uploadLogo = useCallback(
    async (logo: any) => {
      try {
        setLoading(true);

        const { data, error } = await supabase.storage
          .from("branding")
          .upload(`logos/${user.company.id}_${new Date().getTime()}`, logo, {
            contentType: logo.type,
          });

        if (error) {
          throw error;
        }

        const logoUrl = `${process.env.REACT_APP_SUPABASE_URL}/storage/v1/object/public/branding/${data?.path}`;

        await apiRequest("/supabase/companies/update", {
          values: {
            logo: logoUrl,
          },
        });
        await refetch();
        setCompanyLogo(logoUrl);
        showSuccess({
          title: "Logo Updated",
          description: "Your logo was successfully updated.",
        });
      } catch (err) {
        showError({
          title: "Upload Failed",
          description: getErrorMessage(err),
        });
      } finally {
        setLoading(false);
      }
    },
    [showError, showSuccess, user.company.id]
  );

  const onDrop = useCallback(
    (newFiles: any) => {
      uploadLogo(newFiles[0]);
    },
    [uploadLogo]
  );

  const { open } = useDropzone({
    onDrop,
    noClick: true,
    noKeyboard: true,
    maxFiles: 1,
    accept: {
      "image/*": [".png", ".jpeg", ".jpg"],
    },
  });

  useEffect(() => {
    setCompanyLogo(user.company.logo);
  }, [user.company]);

  return (
    <Box>
      <SettingsHeader title="Brand Design" />
      <SettingsDescription text="Customize the LendTech platform with your brand style." />
      <Box>
        <FormControl>
          <FormLabel fontSize="16px" fontWeight="600">
            Logo
          </FormLabel>
          <Box
            bg={
              company_configurations[0] &&
              company_configurations[0]?.ui_prefrences &&
              company_configurations[0]?.ui_prefrences?.background
                ? `${company_configurations[0]?.ui_prefrences?.background}`
                : ""
            }
            p="26px"
            w="240px"
            borderWidth="1px"
            borderColor="gray.50"
            borderRadius="10px"
          >
            {companyLogo ? <Image src={companyLogo} /> : <Image src="/logo.png" />}
          </Box>
        </FormControl>
        <Button
          isLoading={loading}
          mt="12px"
          size="sm"
          variant="secondary"
          isDisabled={permissionEnabled()}
          onClick={open}
        >
          Change Logo
        </Button>
      </Box>
      {/* <Iframe
        url={`${process.env.REACT_APP_DASHBOARD_URL}/register/${user.company.slug}`}
        width="450px"
        height="540px"
        id=""
        className=""
        display="block"
        position="relative"
      /> */}
    </Box>
  );
}
